

const state = () => ({
    users: [],
    user: null,
    successfullysave: false,
    hasErrorInService: false
})

export default state